// Update basket icon

let basket_icons = document.querySelectorAll('.basket.openSideCart');


basket_icons.forEach(basket => {
    if (basket.dataset.cartItems > 0) {
        basket.classList.add('cart-items');
    }
})

// Mega menu submenu hover states

let parent_links = document.querySelectorAll('.sublinks-column-1 .sublink');
let child_menus = document.querySelectorAll('.sublinks-column-2');

parent_links.forEach((child, index) => {
    child.addEventListener('mouseenter', () => {
        child_menus.forEach((el) => {
            el.classList.remove('show');
        })
        let menu_name = child.getAttribute(`data-menu`);
        let menu = document.querySelector(`.sublinks-column-2[data-menu="${menu_name}"]`);
        if (menu) {
            menu.classList.add('show');
        }

        parent_links.forEach((el) => {
            el.classList.remove('hover');
        })

        child.classList.add('hover');

        let sublinksColumns = child.closest('.sublinks-container').querySelector('.sublinks-columns');
        if (child.classList.contains('no-menu') && child.classList.contains('hover')) {
            sublinksColumns.style.background = 'none';
        } else {
            sublinksColumns.style.background = '#f5f7fa';
        }
    })
})

// Reset the menu mega to top link open

let mega_menus = document.querySelectorAll('.top-level-link + .mega-menu-dropdown_outer-wrapper');

mega_menus.forEach((el, index) => {

    el.addEventListener('mouseleave', () => {

        if (el.querySelector('.sublinks-column-2.show')) {
            el.querySelector('.sublinks-column-2.show').classList.remove('show')
        }

        if (el.querySelector('.has-menu.hover')) {
            el.querySelector('.has-menu.hover').classList.remove('hover')
        }

        if (el.querySelector('.no-menu.hover')) {
            el.querySelector('.no-menu.hover').classList.remove('hover')
        }

        setTimeout(() => {
            if (index == 0) {
                el.querySelector('.sublinks-column-2').classList.add('show')
                el.querySelector('.has-menu').classList.add('hover')
                el.querySelector('.no-menu').classList.add('hover')
            }
        }, 500)

        document.querySelector('.sublinks-columns').style.background = '#f5f7fa';
    })
})

let top_links = document.querySelectorAll('.top-level-link');

top_links.forEach((top_link) => {
    top_link.addEventListener('mouseenter', () => {
        let dropdown = top_link.nextElementSibling;

        if (  dropdown ) {
            let navs = dropdown.querySelectorAll(`.sublinks-column-2`);
    
            if (navs.length > 0) {
                navs[0].classList.add('show');
            }
            
            let tabs = top_link.nextElementSibling.querySelectorAll('.has-menu');
            if (tabs.length > 0) {
                tabs[0].classList.add('hover');
            }
        }
    })
});

const megaMenus = document.querySelectorAll('.mega-menu-dropdown_outer-wrapper');

megaMenus.forEach(megaMenu => {
    megaMenu.addEventListener('mouseover', () => {
      const topLevelLink = megaMenu.parentElement.querySelector('.top-level-link');
      if (topLevelLink) {
        topLevelLink.classList.add('active')
      }
    });
  
    megaMenu.addEventListener('mouseout', () => {
      const topLevelLink = megaMenu.parentElement.querySelector('.top-level-link');
      if (topLevelLink) {
        topLevelLink.classList.remove('active'); 
      }
    });
  });